import {ServiceBase} from "../service-base";
import {ISideMenuService} from "./side-menu.service.interface";
import {ISideMenuControllerViewModel} from "./side-menu-controller.view-model.interface";
import {Lazy} from "../../utils/lazy";
import { SideMenuControllerModel } from "./side-menu-controller.model";

export class SideMenuService extends ServiceBase implements ISideMenuService {
    private _agencyBookingSearchSideMenuController: Lazy<ISideMenuControllerViewModel> = new Lazy<ISideMenuControllerViewModel>(() => {
        return new SideMenuControllerModel("side-menu-agency-booking-search", "side-menu-agency-booking-search-content");
    });

    get agencyBookingSearchSideMenuController(): ISideMenuControllerViewModel {
        return this._agencyBookingSearchSideMenuController.value;
    }

    private _agencyMainSideMenuController: Lazy<ISideMenuControllerViewModel> = new Lazy<ISideMenuControllerViewModel>(() => {
        return new SideMenuControllerModel("side-menu-agency-main", "side-menu-agency-main-content");
    });

    get agencyMainSideMenuController(): ISideMenuControllerViewModel {
        return this._agencyMainSideMenuController.value;
    }

    private _hybridMainSideMenuController: Lazy<ISideMenuControllerViewModel> = new Lazy<ISideMenuControllerViewModel>(() => {
        return new SideMenuControllerModel("side-menu-hybrid-main", "side-menu-hybrid-main-content");
    });

    get hybridMainSideMenuController(): ISideMenuControllerViewModel {
        return this._hybridMainSideMenuController.value;
    }
}